import React from 'react'

import './purchasetest.scss'
import axios from 'axios';

import { useState} from "react"
import { Container } from 'react-bootstrap';
import { config } from '../../../config';
import {PushButton} from '../pushbutton/PushButton'
import AITestContext from '../../../contexts/AITestContext'
import { useParams } from "react-router-dom"

export const CheckoutSession = () => {
   
    const [accountCreatePending, setAccountCreatePending] = useState(false);
    const [error, setError] = useState(false);

  let {
    getConnectedAccount,
  } = React.useContext(AITestContext);

    const { creator_id, price, testname } = useParams()

    const startCheckoutSession = async () => {
        setAccountCreatePending(true);
        setError(false);

        console.log("CreatorID:", creator_id)
        
        let res = await getConnectedAccount(creator_id)

        if (res.status === 404)
          {
            console.log("User not found")
            return
          }
         

        let url = ''

        let testprice = Math.round(price * 100)
        // 20% fee
        let fee = Math.round(price * 0.2)

        let connectedaccount = JSON.parse(res.account)
     
        let inputs = {
          currency: 'usd',
          name: testname,
          unit_amount: testprice,
          application_fee_amount:  fee,
          connectedaccountid: connectedaccount.account
        }

        console.log("Start Checkout Session:", inputs)
      
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/purchasetest/checkoutsession", {inputs},{
                    withCredentials:true
                })
            console.log("Response:", res)
            url = res.data.url
           
        } catch(err)
        {
            console.log("Error:", error)
            setAccountCreatePending(false);
            return
           
        }

        setAccountCreatePending(false);
        //url = "https://openai.com"
        window.open(url,'_blank')


    }

    
    return (
        <div>
            
            <Container className="purchaseTestContainer">
            <div>
                <h2 style = {{color:'blue'}}>CHECKOUT SESSION</h2>
                <h6 style = {{color:'blue'}}>Onboard: Hosted</h6>
                <h6 style = {{color:'blue'}}>Managing Payments: Express</h6>
                <h6 style = {{color:'blue'}}>Charge: Destination</h6>
                <h6 style = {{color:'blue'}}>Who pays fees: Platform</h6>
                <h6 style = {{color:'blue'}}>Liable for negative balance: Platform</h6>
                <>
                <h2>Get ready for take off</h2>
                <p>Rocket Rides is the world's leading air travel platform: join our team of pilots to help people travel faster.</p>
                <h2>Add information to start accepting money</h2>
                <p>Matt's Mats partners with Stripe to help you receive payments and keep your personal bank and details secure.</p>
                {!accountCreatePending &&
                  <>
                    <PushButton onClick={startCheckoutSession} label =  'Start Checkout Session'/>
                  </>
                }
                </>
          

           
          {error && <p className="error">Something went wrong!</p>}
          
            <div className="info-callout">
            <p>
            This is a sample app for Stripe-hosted Connect onboarding. <a href="https://docs.stripe.com/connect/onboarding/quickstart?connect-onboarding-surface=hosted" target="_blank" rel="noopener noreferrer">View docs</a>
            </p>
            </div>
          </div>
           
            </Container>
        </div>
    )
}

export default CheckoutSession